import { render, staticRenderFns } from "./short-guest-card.vue?vue&type=template&id=4bd7c8fa&"
import script from "./short-guest-card.vue?vue&type=script&lang=ts&"
export * from "./short-guest-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports